import { render, staticRenderFns } from "./Merchandising.vue?vue&type=template&id=9b9dbe28"
import script from "./Merchandising.vue?vue&type=script&lang=js"
export * from "./Merchandising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports